module.exports = __webpack_public_path__ + "static/media/lixo.2170a5d1.svg";